import styled from "styled-components";
// import palette from "../../../lib/styles/palette";
import React, { useState, useEffect } from "react";

import { useDispatch } from "react-redux";
import { changeBody } from "../../../modules/conveyor/conveyorWriteSlice";

import { gearCouplingData, selectGearCoupling } from "../../../lib/data/gearCoupling-data";
import { fluidCouplingData as FCDataForFB, fluidCouplingSelection as FCSelectionForFB } from "../../../lib/data/fluidCoupling-data-mmm-fb";
import { fluidCouplingData as FCDataForFD, fluidCouplingSelection as FCSelectionForFD } from "../../../lib/data/fluidCoupling-data-mmm-fd";

import { brakeData, selectBrake } from "../../../lib/data/brake-data";
import { holdbackData, selectBackstop } from "../../../lib/data/holdback-data";
// import { toFixedSafe } from "../../../lib/styles/perttierNumber";
import SpeedReducerSingle from "./SpeedReducerSingle";

import { Input, Output, Select } from "../common/SingleInput";

const DriveComponentSingle = ({ drives, resistance, pulleys, fluidCouplings, gearCouplings, reducers, brakes, backstops }) => {
    const dispatch = useDispatch();

    // const [firstReducer, setFirstReducers] = useState(reducers?.[0] || {});
    const [firstFluidCoupling, setFirstFluidCoupling] = useState(fluidCouplings?.[0] || {});
    const [firstGearCoupling, setFirstGearCoupling] = useState(gearCouplings?.[0] || {});
    const [firstBrake, setFirstBrake] = useState(brakes?.[0] || {});
    const [firstBackstop, setFirstBackstop] = useState(backstops?.[0] || {});

    /* Fluid Coupling */
    const handleFluidCouplingTypeSelection = (e) => {
        const { value } = e.target;

        setFirstFluidCoupling(prev => ({
            ...prev,
            type: value,
        }));
    };

    /* 1st Fluid Coupling - Selection */
    useEffect(() => {
        const motorRPM = Number(drives?.[0].motorRPM);
        const selectedMotor = Number(drives?.[0].selectedMotor);

        let fluidCouplingSelection;
        let fluidCouplingData;

        if (firstFluidCoupling.type === 'FB') {
            fluidCouplingSelection = FCSelectionForFB; 
            fluidCouplingData = FCDataForFB;
        } else {
            fluidCouplingSelection = FCSelectionForFD;
            fluidCouplingData = FCDataForFD;
        }

        const index = motorRPM === 1800 ? 0 : motorRPM === 1200 ? 1 : motorRPM === 1500 ? 2 : 3;
        const objFound = fluidCouplingSelection.find(obj => obj.motorRanking === selectedMotor);
        if (!objFound) {
            return;
        }
        const selectedFluidCoupling = objFound.models[index];
        const obj = fluidCouplingData.find(obj => obj.model === selectedFluidCoupling);
        if (!obj) {
            return;
        }

        setFirstFluidCoupling(prev => ({
            ...prev,
            selectedFluidCoupling,
            inertia: obj.inertia,
            weight: obj.weight,
        }))
    }, [drives, firstFluidCoupling.type]);

    /* Gear Coupling */
    const gearCouplingSelection = gearCouplingData.map(coupling => {
        return {
            text: coupling.model,
            value: coupling.allowableTorque,
        }
    });

    const handleGearCouplingChange = (e) => {
        const { name, value } = e.target;

        setFirstGearCoupling(prev => ({
            ...prev,
            [name]: value,
            // allowableTorque: value,
        }))
    };

    const handleGearCouplingSelection = (e) => {
        const { value } = e.target;

        const selected = selectGearCoupling(value);
        if (!selected) return;

        setFirstGearCoupling(prev => ({
            ...prev,
            model: selected.model,
            allowableTorque: selected.allowableTorque,
            maxRPM: selected.maxRPM,
            weight: selected.weight,
            inertia: selected.inertia,
        }));
    }

    /* 1st Gear Coupling - Actual Torque */
    useEffect(() => {
        if (!drives || !pulleys) return;

        const T1 = Number(drives?.[0].tightSideTension?.load);
        const T2 = Number(drives?.[0].slackSideTension?.load);
        const D = Number(pulleys?.[0].diaWithLagging) / 1000;     // 단위환산 mm -> m
        const actualTorqueApplied = Math.ceil((T1 - T2) * D/2);     // N-m

        setFirstGearCoupling(prev => ({
            ...prev,
            actualTorqueApplied,
        }))
    }, [drives, pulleys]);

    /* 1st Gear Coupling - Required Torque, Selection */
    useEffect(() => {
        if (!firstGearCoupling.safetyFactor) return;
        const requiredTorque = firstGearCoupling.safetyFactor * firstGearCoupling.actualTorqueApplied;

        const safetyMargin = Number(firstGearCoupling.allowableTorque) / requiredTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setFirstGearCoupling(prev => ({
            ...prev,
            requiredTorque: Math.ceil(requiredTorque),
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [firstGearCoupling.actualTorqueApplied, firstGearCoupling.allowableTorque, firstGearCoupling.safetyFactor]);

    /* Brake */
    const brakeRanking = brakeData.map(brake => {
        return {
            text: brake.model,
            value: brake.torque,
        }
    });

    const handleBrakeChange = (e) => {
        const { name, value } = e.target;

        setFirstBrake(prev => ({
            ...prev,
            [name]: value,              // name: model
        }));
    }

    const handleBrakeSelection = (e) => {
        const { value } = e.target;
        const selected = selectBrake(value);
        if (!selected) return;

        setFirstBrake(prev => ({
            ...prev,
            // requiredTorque,
            model: selected.model,
            torque: selected.torque,
            inertia: selected.inertia,
            weight: selected.weight,
        }))
    }

    /* 1st Brake - Selection */
    useEffect(() => {
        if (!drives[0].ratedMotorTorque) return;

        const motorTorque = Number(drives?.[0].ratedMotorTorque);      // kg-m
        const requiredTorque = 1.0 * motorTorque;                      // kg-m

        const safetyMargin = Number(firstBrake.torque) / requiredTorque;
        const isSafe = safetyMargin < 1 ? false : true;
        setFirstBrake(prev => ({
            ...prev,
            requiredTorque,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));

    }, [drives, firstBrake.torque]);

    /* Backstop */
    const backstopRanking = holdbackData.map(holdback => {
        return {
            text: holdback.model,
            value: holdback.torque,
        }
    });

    const handleBackstopSelection = (e) => {
        const { value } = e.target;
        const selected = selectBackstop(value);
        if (!selected) {
            return;
        }

        setFirstBackstop(prev => ({
            ...prev,
            model: selected.model,
            torque: selected.torque,
            weight: selected.weight,
        }));
    }

    /* 1st Backstop - Reverse Torque 계산 */
    useEffect(() => {
        if (!resistance?.reverse?.load) return;
        const reverseForce = Number(resistance?.reverse?.load);
        if (reverseForce < 0) {
            return;
        }
        const firstDrivePulley = pulleys?.find(pulley => pulley.application === '1st Drive');
        if (!firstDrivePulley) {
            return;
        }
        const pulleyDia = Number(firstDrivePulley.diaWithLagging);
        const reverseTorque = Math.ceil(pulleyDia / 2000 * reverseForce);
        const safetyMargin = Number(firstBackstop.torque) / reverseTorque;
        const isSafe = safetyMargin < 1 ? false : true;

        setFirstBackstop(prev => ({
            ...prev,
            reverseTorque,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }))
        
    }, [firstBackstop.torque, pulleys, resistance?.reverse]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'fluidCouplings',
                value: [firstFluidCoupling],
            })
        );
    }, [dispatch, firstFluidCoupling]);

    useEffect(() => {
        dispatch(
            changeBody({
                key: 'gearCouplings',
                value: [firstGearCoupling],
            }),
        );
    }, [dispatch, firstGearCoupling]);

    // useEffect(() => {
    //     dispatch(
    //         changeBody({
    //             key: 'reducers',
    //             value: [firstReducer],
    //         }),
    //     );
    // }, [dispatch, firstReducer]);

    useEffect(() => {
        dispatch(
            changeBody({
                key: 'brakes',
                value: [firstBrake],
            }),
        );
    }, [dispatch, firstBrake]);

    useEffect(() => {
        dispatch(
            changeBody({
                key: 'backstops',
                value: [firstBackstop],
            }),
        );
    }, [dispatch, firstBackstop]);

    return (
        <>
            <SpeedReducerSingle reducers={reducers} />
            {/* Fluid Coupling */}
            <SubTitle>Fluid Coupling(s):</SubTitle>
            <Output 
                label="Installed Motor"
                variable="-"
                variableName="-"
                unit="kW"
                value={drives?.[0].selectedMotor}
            />
            <Output 
                label="Motor RPM"
                variable="RPM"
                variableName="-"
                unit="1/min"
                value={drives?.[0].motorRPM}
            />
            <Select
                label="Fluid Coupling Type"
                variable="-"
                variableName="type"
                unit="-"
                value={firstFluidCoupling.type}
                options={[{ text: 'FB形式', value: 'FB' }, { text: 'FD形式', value: 'FD' }]}
                onChange={handleFluidCouplingTypeSelection}
            />
            <Output 
                label="Selected Model"
                variable="-"
                variableName="-"
                unit="-"
                value={firstFluidCoupling.selectedFluidCoupling}
            />
            {/* <Select
                label="Model No."
                variable="-"
                variableName="model"
                unit="-"
                value={firstFluidCoupling.model}
                options={fluidCouplingSelection}
                onChange={null}
                isRequired
            /> */}

            {/* Gear Coupling */}
            <SubTitle>Gear Coupling(s):</SubTitle>
            <Output
                label="Actual Torque applied at Pulley Shaft"
                variable="-"
                variableName="-"
                unit="N-m"
                value={firstGearCoupling.actualTorqueApplied}
            />
            <Input
                label="Safety Factor of Gear Coupling"
                variable="-"
                unit="-"
                variableName="safetyFactor"
                value={firstGearCoupling.safetyFactor}
                referenceValue={1.5}
                onChange={handleGearCouplingChange}
            />
            <Output
                label="Required Torque for Gear Coupling"
                variable="-"
                unit="N-m"
                variableName="requiredTorque"
                value={firstGearCoupling.requiredTorque}
            />
            <Select
                label="Model No."
                variable="-"
                variableName="allowableTorque"
                unit="-"
                value={firstGearCoupling.allowableTorque}
                options={gearCouplingSelection}
                onChange={handleGearCouplingSelection}
            />
            <Output
                label="Rated Torque of Gear Coupling Selected"
                variable="-"
                unit="N-m"
                variableName="allowableTorque"
                value={firstGearCoupling.allowableTorque}
            />
            <Output
                label="Safety Margin"
                variable="-"
                unit="-"
                variableName="-"
                value={firstGearCoupling.safetyMargin}
                isSafe={firstGearCoupling.isSafe}
            />

            {/* Brake */}
            <SubTitle>Brake(s):</SubTitle>
            <Input
                label="Braking Torque Required"
                variable="-"
                unit="N-m"
                variableName="requiredTorque"
                value={firstBrake.requiredTorque}
                referenceValue={null}
                onChange={handleBrakeChange}
            />
            <Select
                label="Model No."
                variable="-"
                variableName="model"
                unit="-"
                value={firstBrake.torque}
                options={brakeRanking}
                onChange={handleBrakeSelection}
                isRequired
            />
            <Output
                label="Rated Torque of Brake Selected"
                variable="-"
                unit="N-m"
                variableName="brakeTorque"
                value={firstBrake.torque}
            />
            <Output
                label="Safety Margin"
                variable="-"
                unit="-"
                variableName="-"
                value={firstBrake.safetyMargin}
                isSafe={firstBrake.isSafe}
            />

            {/* Back-stop */}
            <SubTitle>Back-stop(s):</SubTitle>
            <Output
                label="Reverse Torque"
                variable="-"
                variableName="reverseTorque"
                unit="N-m"
                value={firstBackstop.reverseTorque}
            />
            <Select
                label="Model No."
                variable="-"
                variableName="model"
                unit="-"
                value={firstBackstop.torque}
                options={backstopRanking}
                onChange={handleBackstopSelection}
                isRequired
            />
            <Output
                label="Rated Torque of Backtop Selected"
                variable="-"
                unit="N-m"
                variableName="backstopTorque"
                value={firstBackstop.torque}
            />
            <Output
                label="Safety Margin"
                variable="-"
                unit="-"
                variableName="-"
                value={firstBackstop.safetyMargin}
                isSafe={firstBackstop.isSafe}
            />
        </>
    );
};

export default DriveComponentSingle;


const SubTitle = styled.p`
    margin-left: 1rem;
    font-weight: 800;
`;
